import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var AnchorButton = function AnchorButton(_ref) {
  var href = _ref.href,
      className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    onClick: onClick,
    className: classNames('Button', className)
  }, children);
};

AnchorButton.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired
};
export default AnchorButton;